export const AI_GATEWAY_API_URL = "https://ai-gateway.convex.dev/v1";
